import { EmailSettings } from '../../data/settings'
import { postJson } from '../fetchers'

export async function requestUpdateEmailSettings(emailSettings: EmailSettings) {
  return await postJson(`/Settings/Email/`, emailSettings)
}
